<template>
  <div id="mine">
    <div class="mine-one">
      <div class="info">
        <div class="thumbnail">
          <van-image
            round
            width="4rem"
            height="4rem"
            fit="cover"
            :src="userInfo.thumbnail"
          />
        </div>
        <div class="right">
          <div class="name-integral">
            <div class="name">{{userInfo.username}}</div>
            <div class="integral">积分：{{userInfo.integral}}</div>
          </div>
          <div class="school-class">
            <div class="school">{{userInfo.village}}</div>
            <div class="class">{{userInfo.class}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mine-two">
      <img src="https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782900354757.png" width="100%" alt="">
      <div class="lists">
        <div class="list" v-for="(v, k) in integralHistory" :key="k">
          <div class="target">{{v.target_word}}</div>
          <div class="integral">{{v.integral}}分</div>
        </div>

        <div class="tip">
          只显示最近10条记录
        </div>
      </div>

      
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from 'vant';
import { getFanzhaUserInfo, getIntegralHistory } from '@/api/fanzha';

export default {
  name: "fanzha_mine",
  data(){
    return {
      themeId: 3,
      userInfo: {},
      integralHistory: []
    }
  },
  mounted(){
    getFanzhaUserInfo({themeId: this.themeId}).then((res) => {
      // console.log(res);
      if(res.code == 1){
        if(res.data == null){
          this.$route.push({
            path: `/fanzha/list`
          })
        }else{
          this.userInfo = res.data;
        }
      }else{
        Toast.fail(res.msg);
      }
    });

    getIntegralHistory({themeId: this.themeId}).then((res) => {
      if(res.code == 1){
        this.integralHistory = res.data;
      }else{
        Toast.fail(res.msg);
      }
    });

  }
}
</script>

<style lang="less" scoped>
#mine {
  .mine-one {
    background-image: url(https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782899182100.png);
    background-repeat: no-repeat;
    background-size: 100%;
    height: 215px;
    color: #000;
    .info {
      display: flex;
      height: 100%;
      width: 85vw;
      margin: auto;
      align-items: center;
      font-size: 14px;
      .right {
        flex: 1;
        margin-left: 10px;
        .name-integral {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 5px;
          margin-bottom: 10px;
          border-bottom: 1px solid #ff5f01;
          .name {
            color: #5d82da;
          }
          .integral {
            color: #ff5f01;
          }
        }
        .school-class {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 5px;
          border-bottom: 1px solid #ff5f01;
          .class {
            border-left: 1px solid #ff5f01;
            padding-left: 5px;
          }
        }
      }
    }
  }

  .mine-two {
    
    .lists {
      background-image: url(https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782902517484.png);
      background-repeat: repeat-y;
      background-size: 100%;
      min-height: 230px;
      color: #000;
      width: 100%;
      margin: auto;
      padding-top: 10px;
      padding-bottom: 10px;
      .list {
        // background-image: url(~@/assets/images/fanzha2023/integral-history-list.png);
        // background-repeat: no-repeat;
        // background-size: 100%;
        background-color: rgba(255, 255, 255, 0.3);
        border: 2px solid #fff;
        border-radius: 15px;
        box-shadow: 0 0 10px #7362fe ;
        width: 75%;
        height: 38px;
        line-height: 38px;
        display: flex;
        margin: 0px auto 20px auto;
        padding: 0 20px;
        justify-content: space-between;
        align-items: center;
        .integral {
          text-align: center;
          width: 90px;
          border-radius: 15px;
          line-height: 30px;
          color: #fff;
          background-color: #7362fe;
        }
      }
      .tip{
        text-align: center;
        color: #7362fe;
      }
    }
  }
}

</style>